/* unplugin-vue-components disabled */import { render } from "./FormAreas.vue?vue&type=template&id=11d87e86&ts=true"
import script from "./FormAreas.vue?vue&type=script&lang=ts"
export * from "./FormAreas.vue?vue&type=script&lang=ts"

import "./FormAreas.vue?vue&type=style&index=0&id=11d87e86&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__